<template>
  <div class="ma-2 ml-3 site_content">
    <div class="flex">
      <comboFarm
        @fromFarm="farmInfo"
      />
      <datePicker
        :fr_date="fr_date" 
        :to_date="to_date" 
        @update:fr_date="updateFrDate"
        @update:to_date="updateToDate"
        @refresh="refreshData" 
      />
    </div>

    <div class="chart_layout">
      <Chart 
        chartType="Line"
        :chartData="growChartData"
        :chartOptions="lineChartOptions"
        :chartSize="chartSize" 
      />
    </div>

    <div class="table_layout">
      <v-data-table dense
          fixed-header
          :footer-props="{
            itemsPerPageOptions:[-1]
          }"
          :items-per-page="-1" 
          :headers="headers"
          :items="items"
          no-data-text="측정된 자료가 없습니다."
          class="table_content"
          height="50vh"
          item-key="dateYm"
          single-select
          hide-default-footer
          :sort-by= "['dateYm']"
          :sort-desc= "[true]"
        >
      </v-data-table>
    </div>
  </div>
</template>

<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";

import comboFarm from "@/components/combo/farm.vue";
import datePicker from "@/components/compo/datePicker_month.vue";
import Chart from "@/components/chart/Chart.vue"
import { lineChartOptions } from "@/components/chart/option.js"; 


export default {
  name: 'Grow',
  components:{
    comboFarm,
    datePicker,
    Chart
  },
  async created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 

  },

  data(){
    let cdate = new Date();
    let toDate = dateUtil.format(cdate, "yyyy-MM");

    let frdate = new Date(cdate.setMonth(cdate.getMonth() - 12));
    let frDate = dateUtil.format(frdate, "yyyy-MM");

    return {
      fr_date: frDate,
      to_date: toDate,

      farmData: { company: {}, farm: {} },

      lineChartOptions:lineChartOptions,
      
      chartSize: {
        height:'250px',
        width: '83vw',
      },

      growChartData:{},

      items:[],
      chartitems:{},

      loading:false,
      headers: [
        { text: '날짜', align: 'left', value: 'date_ym', filterable: true, sortable: true, groupable: false, width: "130px", show: true,divider: true},
        { text: '모돈', align: 'center', value: 'sow', filterable: true, sortable: true, groupable: false, width: "100px",divider: true, show: true },
        { text: '후보돈', align: 'center', value: 'gilt', filterable: false, sortable: true, groupable: false, width: "110px",divider: true, show: true },
        { text: '웅돈', align: 'center', value: 'boar', filterable: false, sortable: true, groupable: false, width: "110px", divider: true, show: true },
        { text: '자돈', align: 'center', value: 'weaner', filterable: false, sortable: true, groupable: false, width: "110px", divider: true, show: true },
        { text: '육성돈', align: 'center', value: 'grower', filterable: false, sortable: true, groupable: false, width: "110px", divider: true, show: true },
        { text: '비육돈', align: 'center', value: 'fattener', filterable: false, sortable: true, groupable: false, width: "110px", divider: true, show: true },
        { text: '총 재고두수', align: 'center', value: 'total', filterable: false, sortable: true, groupable: false, width: "110px", show: true },
      ],


    }
  },
  methods:{
    farmInfo(data){
      // console.log(data)
      this.farmData = data;
      this.refreshData();
    },
    updateFrDate(date) {
      this.fr_date = date;
    },
    updateToDate(date) {
      this.to_date = date;
    },
    refreshData(){
      this.GrowData();
    },
    GrowData(){
      // console.log(this.fr_date, this.to_date)
      this.$store.commit("resMessage","");
      this.loading = true;

      Apis.listCountHeadOfFarmPerMonth({
        farmNo : this.farmData.farm.no,
        from : this.fr_date,
        to : this.to_date
      },(res) => {  
        if (res.result) {
        this.items = res.data.reverse();

        let dateYm = [];
        let boar = [];
        let fattener = [];
        let gilt = [];
        let grower = [];
        let sow = [];
        let weaner = [];

        // console.log(this.items)
        this.items.forEach(function (item){
          dateYm.push(item.date_ym);
          boar.push(item.boar);
          fattener.push(item.fattener);
          gilt.push(item.gilt);
          grower.push(item.grower);
          sow.push(item.sow);
          weaner.push(item.weaner);
        })

        this.chartitems = {
          dateYm : dateYm,
          boar : boar,  //웅돈
          fattener : fattener, //비육돈
          gilt : gilt,  //후보돈
          grower : grower, //육성돈
          sow : sow,  //모돈
          weaner : weaner //자돈
        }
        // console.log(this.chartitems)

        this.growChartData = this.growChart();

        this.$store.commit("resMessage",res.message);
      } else {
          alert(res.message);
        }
        this.loading = false;
      }).catch( (err) => {  // API 오류 처리
          console.log("listCountHeadOfFarmPerMonth API 호출 오류",err)
          this.loading = false;
      })
    },
    growChart(){
      return{
        labels:this.chartitems.dateYm,
        datasets: [
          {
            label: '모돈', 
            data:this.chartitems.sow,
            backgroundColor: 'rgba(90, 114, 160, 0.6)', 
            borderColor: 'rgba(90, 114, 160, 0.6)', 
          },

          {
            label: '후보돈', 
            data:this.chartitems.gilt, 
            backgroundColor:'rgba(26, 33, 48, 0.6)',
            borderColor: 'rgba(26, 33, 48, 0.6)',
          },

          {
            label: '웅돈', 
            data:this.chartitems.boar, 
            backgroundColor: 'rgba(131, 180, 255, 0.6)', 
            borderColor: 'rgba(131, 180, 255, 0.6)', 
          },

          {
            label: '자돈', 
            data:this.chartitems.weaner, 
            backgroundColor:'rgba(29, 93, 155, 0.6)',
            borderColor: 'rgba(29, 93, 155, 0.6)',
          },

          {
            label: '육성돈', 
            data:this.chartitems.grower, 
            backgroundColor: 'rgba(244, 209, 96, 0.6)',
            borderColor:  'rgba(244, 209, 96, 0.6)',
          },

          {
            label: '비육돈', 
            data:this.chartitems.fattener, 
            backgroundColor: "rgba(124, 9, 2, 0.4)",
            borderColor:   "rgba(124, 9, 2, 0.4)",
          },
        ]
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/base.scss';
@import '../../style/table_mb.scss';
.table_layout{
  margin-top:10px;
  padding:0 !important;
}
.table_content{
  height:50vh;
  min-height:250px;
}
@media only screen and (max-width: 768px){
  .calendar{
    height:30px !important;
  }
}
</style>